import React, { useContext, useState, useEffect } from 'react'
import { Button, Row, Col, Form } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { baseURL } from '../Network/Config'
import { deleteBookingLocation, listBookingLocation } from '../Network/Booking'
import { Link, useHistory } from 'react-router-dom'
import { repeatStatus } from './BookingStatus'
import { Loading } from '../Library'
import "./Booking.css"
import thumbnail from '../asset/image/thumbnail.png'
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck, faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import { AlertModalContext } from '../Library/AlertModalContext'

function Booking() {
    const history = useHistory()
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.booking
    const [isLoading, setIsLoading] = useState(false)
    const [bookingLocationList, setBookingLocationList] = useState([])
    const [page, setPage] = useState(1)
    const size = 12
    const [isLast, setIsLast] = useState(false)

    const [searchKeyword, setSearchKeyword] = useState('')
    var searchTimeout = null

    const formatTime = (time) => {
		const currentDate = dayjs().format("YYYY-MM-DD")
		const datewithTime = `${currentDate} ${time}`
		const datewithTimeFormatted = dayjs(datewithTime).format("H:mm")
		return datewithTimeFormatted
	}

    const fetchData = (page, size, isReplace, searchKeyword) => {
        setIsLoading(true)
        listBookingLocation(page, size, searchKeyword,
            (data)=>{
                if(isReplace){
                    setBookingLocationList(data)
                    console.log(data)
                }else{
                    data.forEach((item) => {
                        setBookingLocationList(prev => [...prev, item])
                    })
                }
                if(data.length < size){
                    setIsLast(true)
                }
                setIsLoading(false)
            },
            (error)=>{
                setIsLoading(false)
            })
    }

    const loadMore = () => {
        const nextPage = page + 1
        setPage(nextPage)
        fetchData(nextPage, size, false, searchKeyword)
    }

    const onScroll = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(!isLast){
                loadMore()
            }
        }
    }

    const onSearch = (event) =>{
        const word = event.target.value
        setPage(1)
        setSearchKeyword(word)
        setIsLast(false)

        clearTimeout(searchTimeout)
        searchTimeout = setTimeout(()=>{
            fetchData(1, size, true, word)
        }, 500)
    }

    const onDeleteLocation = (locationId) => {
        alertModal.setTitle(lang.delete_location)
        alertModal.setDescription(lang.sure_to_delete_location)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setIsLoading(true)
                    deleteBookingLocation(locationId,
                        ()=>{
                            setIsLoading(false)
                            fetchData(1, page * size, true, searchKeyword)
                        },
                        ()=>{
            
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    useEffect(()=>{
        fetchData(page, size, true, searchKeyword)
    },[])

    return (
        <div id="booking">
            { isLoading ? <Loading/>: null }
            <div className="top-header">
                <Button onClick={()=>history.push("/booking/create")}>
                    {lang.create_location}
                </Button>
                <Form.Control 
                placeholder={lang.search_location}
                type="search"
                onChange={onSearch}
                style={{ width: 200 }}/>
            </div>
            { searchKeyword !== "" ?
            <div className="search-indicator">
                <b>{bookingLocationList.length}</b>
                <span>{` ${lang.search_result}`}</span>
            </div>
            : null
            }
            <div className="booking-container" onScroll={onScroll}>
                <Row>
                    { bookingLocationList.map((item, key) =>
                    <Col lg={6} key={key}>
                        <BookingLocationItem
                        image={item.imagePath}
                        locationName={item.locationName}
                        detail={item.detail}
                        to={`/booking/view/${item.id}`}
                        start={formatTime(item.startOperation)}
                        end={formatTime(item.endOperation)}
                        status={item.status}
                        repeat={item.repeat}
                        onEdit={()=>{ history.push(`/booking/edit/${item.id}`) }}
                        onDelete={()=>{ onDeleteLocation(item.id) }}
                        />
                    </Col>
                    )}
                </Row>
                { !isLast && bookingLocationList.length > 0 ?
                <div style={{ textAlign: 'center' }}>
                    <Button onClick={()=> loadMore()}>
                        {lang.load_more}
                    </Button>
                </div>
                : null
                }
                { bookingLocationList.length === 0 ?
                <div style={{ textAlign: 'center', marginTop: 20, color: 'gray' }}>
                    <div style={{ fontSize: 50, marginBottom: 10 }}>
                        <FontAwesomeIcon icon={faCalendarCheck} />
                    </div>
                    <div>{lang.no_booking_location}</div>
                </div>
                : null
                }
            </div>
        </div>
    )
}

function BookingLocationItem({ locationName, detail, image, start, end, repeat, status, to, onEdit, onDelete }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.booking
    var repeatDate = lang.no_status
    switch(repeat){
		case(repeatStatus.EVERY_DAY):
			repeatDate = lang.every_day
			break
		case(repeatStatus.EVERY_WEEKDAY):
			repeatDate = lang.every_week_day
			break
		case(repeatStatus.EVERY_WEEKEND):
			repeatDate = lang.every_week_end
			break
	}

    return(
        <Link className="booking-location-item" to={to}>
            <div>
                <img 
                src={image !== null ? `${baseURL}${image}` : thumbnail} 
                className="location-img"
                loading="lazy"/>
            </div>
            
            <div style={{ marginLeft: 18 }}>
                <div className="title">{locationName}</div>
                <div className="detail">{detail}</div>
                <div style={{ marginTop: 8 }}>
                    <b>{lang.operation}</b>
                </div>
                <div>{start} - {end} {repeatDate}</div>

                <div className="action">
                    <Button
                    size='sm'
                    onClick={(e)=>{
                        e.preventDefault()
                        onEdit()
                    }}>
                        <FontAwesomeIcon icon={faPen}/>
                    </Button>
                    <Button 
                    variant='danger' 
                    size='sm'
                    style={{ marginLeft: 10 }}
                    onClick={(e)=>{
                        e.preventDefault()
                        onDelete()
                    }}
                    >
                        <FontAwesomeIcon icon={faTrash}/>
                    </Button>
                </div>
            </div>
            
        </Link>
    )
}

export default Booking
